import { StyleSheet } from 'aphrodite/no-important';
import { color, fontWeight } from '../../../shared/styles/vars';
import { media } from '../../../shared/styles/constants';

export const styles = StyleSheet.create({
    modal: {
        position: 'relative',
        top: '0',
        left: '0px',
        right: '0px',
        bottom: '0px',
        maxWidth: '1240px',
        margin: 'auto',
        outline: 'none',
        '-webkit-transform':'translateZ(0)',

        [media.LAPTOP]: {
            maxWidth: 1010,
        },

        [media.TABLET]: {
            maxWidth: 750
        },

        [media.MOBILE]: {
            maxWidth: 767,
            height: 'auto',
        }
    },

    overlay: {
        position: 'fixed',
        top: '111px',
        left: '0px',
        right: '0px',
        bottom: '0px',
        backgroundColor: color.cobaltBlue,
        boxShadow: '0 1px 5px 0 rgba(0, 0, 0, 0.3)',
        zIndex: 100001,
        height: 'auto',
        width: '100%',

        [media.AT_LEAST_TABLET]: {
            display: 'table'
        },
        [media.MOBILE]: { 
            overflowY: 'scroll',
            '-webkit-overflow-scrolling' : 'touch',
            height: '100%',
            top: '0px',
            zIndex: 100006,
            '::-webkit-scrollbar': { 
                display: 'none',
            }
        }
    },

    overlayBg: {
        position: 'fixed',
        left: '0',
        top: '0',
        width: '100%',
        height: '100%',
        zIndex: 999,
        opacity: '0.7',
        backgroundColor: '#1e242d'
    },

    vmHeader:{
        display: 'none',

        [media.MOBILE]: {
            display:'flex',
            alignItems: 'center',
            height: '45px',
            padding: '0 15px',
        }
    },

    vmContainer: {
        width: '100%',
        display: 'inline-flex',
        height: '100%',
        paddingTop: '20px',

        [media.MOBILE]: {
            display: 'block',
            padding: '0',
        }
    },

    vmPlayerContainer: {
        width: 800,
        height: '100%',

        [media.LAPTOP]: {
            width: 663,
        },
        [media.TABLET]: {
            width: 442,
        },
        [media.MOBILE]: {
            width: '100%',
            float: 'none',
        },
        [media.SMALL]: {
            width: '100%',
            float: 'none',
        }
    },

    vmPlayerSizes: {
        width: '100%',
        minHeight: '450px',
        backgroundColor: color.black,

        [media.LAPTOP]: {
            minHeight: 373
        },
        [media.TABLET]: {
            minHeight: 249
        },
        [media.MOBILE]: {
            width: '100%',
            minHeight: '230px',
        },
        [media.SMALL]: {
            width: '100%',
            minHeight: '211px',
        }
    },
    

    vmPlayerMeta:{
        [media.MOBILE]: {
            margin: '0px 10px',
            transition: 'all .3s ease-out',
        }

    },


    hideMeta: {
        display: 'none',
    },

    vmMoreVideos: {
        width: '360px',
        height: '100%',
        marginLeft: 30,
        float: 'right',
        [media.LAPTOP]: {
            width: '306px',
            marginLeft: '20px',
            float: 'right',
        },
        [media.TABLET]: {
            width: '290px',
            marginLeft: '15px'
        },

        [media.MOBILE]:{
            float: 'left',
            margin: '0px 10px',
            width: 'auto'
        }
    },

    vmMoreCont: {
        overflowY: 'scroll',
        // '-webkit-overflow-scrolling': 'touch',
        '::-webkit-scrollbar': { 
            display: 'none',
        },

        [media.DESKTOP]:{
            height: 510,
        },
        [media.LAPTOP] : {
            height: 440,
        },
        [media.TABLET] : {
            height: 340
        },
        [media.MOBILE]: {
            maxHeight: 410
        },
        [media.SMALL]: {
            maxHeight: 275
        }
    },

    title: {
        fontFamily: 'Antenna',
        fontSize: '18px',
        fontWeight: fontWeight.bold,
        lineHeight: 1.39,
        textAlign: 'left',
        color: color.white,
        margin: '10px 0',

        [media.MOBILE]: {
            fontSize: 14,
        }
    },

    props: {
		marginBottom: '14px',
		fontSize: '10px',
		lineHeight: '1.43em',
		color: color.gray,
		display: 'flex',
		alignItems: 'center',
		fontWeight: fontWeight.semibold
    },
    
	category: {
        marginRight: '5px',
        textTransform: 'uppercase',
		':before': {
			content: '"|"',
			margin: '0 5px'
        }
        
    },
    compTitle: {
        fontFamily: 'Antenna',
        fontSize: '13px',
        fontWeight: fontWeight.semibold,
        letterSpacing: '2px',
        textAlign: 'center',
        color: color.white,
        textTransform: 'uppercase',
    },

    divider: {
        width:'100%',
        height: '1px',
        opacity: 0.1,
        backgroundColor: color.white,
        display: 'block',
        margin: '20px 0'
    },

    closeButton: {
        position: 'absolute',
        width: '20px',
        height: '20px',
        right: 0,

        [media.MOBILE]: {
            right: '15px',
            top: '12px',
        },
    }, 

    showMore: {
        opacity: 0.5,
        fontFamily: 'Antenna',
        fontSize: '11px',
        fontWeight: fontWeight.semibold,
        fontStyle: 'normal',
        fontStretch: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        textAlign: 'center',
        color: color.white,
        display: 'block',
        textDecoration: 'none'
    }
});



// WEBPACK FOOTER //
// ./react-app-src/videoModal/components/styles/VideoModalStyles.js